document.addEventListener('DOMContentLoaded', function() {
  // Read configuration from Liquid
  const configEl = document.getElementById('myfamily-config');
  const LIQUID_CONFIG = configEl ? JSON.parse(configEl.textContent) : null;

  if (!LIQUID_CONFIG) {
    console.error('MyFamily Configurator: Missing configuration data');
    return;
  }

  // Configuration constants
  const CONFIG = {
    PRICES: {
      CHARACTER: LIQUID_CONFIG.prices.character,
      DECORATION: LIQUID_CONFIG.prices.decoration,
      BACKGROUND: LIQUID_CONFIG.prices.background,
      CALLIGRAPHY: LIQUID_CONFIG.prices.calligraphy,
      CUSTOM_PHRASE: LIQUID_CONFIG.prices.custom_phrase,
      FREE_DECORATIONS_LIMIT: LIQUID_CONFIG.prices.free_decorations_limit
    },
    SELECTORS: {
      STEPS: '.configurator-step',
      PROGRESS_STEPS: '.progress-step',
      PREV_BTN: 'prev-btn',
      NEXT_BTN: 'next-btn',
      ADD_TO_CART_BTN: 'add-to-cart-btn',
      CART_TRIGGER: 'cart-trigger',
      CART_DRAWER: 'cart-drawer',
      CART_OVERLAY: 'cart-overlay',
      CART_CLOSE: 'cart-close',
      CART_ITEMS: 'cart-items',
      CART_TOTAL: 'cart-drawer-total',
      CART_COUNT: 'cart-count',
      HEADER_CART_WRAPPER: 'header-cart-wrapper',
      HEADER_CART_BTN: 'header-cart-btn',
      HEADER_CART_COUNT: 'header-cart-count',
      HEADER_CART_DRAWER: 'header-cart-drawer',
      HEADER_CART_OVERLAY: 'header-cart-overlay',
      HEADER_CART_CLOSE: 'header-cart-close',
      DROPDOWN_ITEMS: 'dropdown-items'
    }
  };

  // State management
  const state = {
    currentStep: 1,
    totalSteps: 6,
    data: {
      frame: null,
      framePrice: 0,
      background: null,
      backgroundPrice: 0,
      characters: [],
      decorations: [],
      phraseType: 'standard',
      phrase: '',
      calligraphy: 'standard',
      arrangement: 'linea'
    },
    cart: {
      item_count: 0,
      items: [],
      total_price: 0
    }
  };

  // Helper: Format currency
  const formatMoney = (amount) => `${amount}€`; // Simplified for this context
  const formatMoneyCents = (cents) => `${(cents / 100).toFixed(2)}€`;

  // Helper: Get DOM element safely
  const getEl = (id) => document.getElementById(id);
  const query = (selector) => document.querySelector(selector);
  const queryAll = (selector) => document.querySelectorAll(selector);

  // Core Logic
  const Configurator = {
    init() {
      this.bindEvents();
      
      // Handle deep linking for steps
      const urlParams = new URLSearchParams(window.location.search);
      const stepParam = urlParams.get('step');
      if (stepParam) {
        const step = parseInt(stepParam);
        if (step >= 1 && step <= state.totalSteps) {
          state.currentStep = step;
        }
      }

      this.updateUI();
      this.fetchCart(); // Initial cart fetch
      this.initDogPagination();
    },

    initDogPagination() {
      const PAGE_SIZE = 24;
      const container = getEl('dog-images-grid');
      const loadMoreBtn = getEl('load-more-dogs-btn');
      const loadMoreContainer = getEl('dog-load-more-container');
      
      if (!container || !loadMoreBtn) return;

      const allDogs = Array.from(container.querySelectorAll('.animal-option[data-animal="dog"]'));
      let visibleCount = PAGE_SIZE;

      // Initially hide dogs beyond PAGE_SIZE
      allDogs.forEach((el, index) => {
        if (index >= PAGE_SIZE) {
          el.style.display = 'none';
        }
      });

      if (allDogs.length > PAGE_SIZE) {
        loadMoreContainer.style.display = 'block';
      }

      loadMoreBtn.addEventListener('click', () => {
        const nextCount = visibleCount + PAGE_SIZE;
        
        for (let i = visibleCount; i < nextCount && i < allDogs.length; i++) {
          allDogs[i].style.display = ''; // Reset to default (grid/block)
        }

        visibleCount = nextCount;

        if (visibleCount >= allDogs.length) {
          loadMoreContainer.style.display = 'none';
        }
      });
    },

    bindEvents() {
      // Navigation
      getEl(CONFIG.SELECTORS.PREV_BTN)?.addEventListener('click', () => this.changeStep(-1));
      getEl(CONFIG.SELECTORS.NEXT_BTN)?.addEventListener('click', () => this.changeStep(1));
      
      // Progress Steps Navigation
      queryAll(CONFIG.SELECTORS.PROGRESS_STEPS).forEach(el => {
        el.addEventListener('click', (e) => {
          const step = parseInt(e.currentTarget.dataset.step);
          this.goToStep(step);
        });
      });
      
      // Frame Selection
      queryAll('.frame-option').forEach(el => {
        el.addEventListener('click', (e) => this.handleFrameSelection(e));
      });

      // Background Selection
      queryAll('.background-option').forEach(el => {
        el.addEventListener('click', (e) => this.handleBackgroundSelection(e));
      });

      // Category Selection
      queryAll('.category-btn').forEach(el => {
        el.addEventListener('click', (e) => this.handleCategorySelection(e));
      });

      // Character Type Selection
      const typeSelectors = ['.woman-option', '.man-option', '.boy-option', '.girl-option', '.baby-option', '.animal-option'];
      typeSelectors.forEach(selector => {
        queryAll(selector).forEach(el => {
          el.addEventListener('click', (e) => this.handleTypeSelection(e, selector));
        });
      });

      // Animal Type Toggle (Dog/Cat)
      queryAll('.animal-type-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const type = e.target.dataset.animalType;
          
          // Update buttons
          queryAll('.animal-type-btn').forEach(b => b.classList.remove('active'));
          e.target.classList.add('active');

          // Show/Hide grids
          const dogWrapper = getEl('dog-content-wrapper');
          const catGrid = getEl('cat-images-grid');
          
          if (type === 'dog') {
            if (dogWrapper) dogWrapper.style.display = 'block';
            if (catGrid) catGrid.style.display = 'none';
          } else {
            if (dogWrapper) dogWrapper.style.display = 'none';
            if (catGrid) catGrid.style.display = 'grid';
          }
        });
      });

      // Girl Type Toggle (Ragazzina/Bambina)
      queryAll('.girl-type-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const type = e.target.dataset.girlType;
          
          // Update buttons
          queryAll('.girl-type-btn').forEach(b => {
            b.classList.remove('active');
            b.style.background = '#fff';
            b.style.color = '#333';
            b.style.borderColor = '#e0e0e0';
          });
          e.target.classList.add('active');
          e.target.style.background = '#dd1ad7';
          e.target.style.color = 'white';
          e.target.style.borderColor = '#dd1ad7';

          // Show/Hide grids
          const ragazzineGrid = getEl('ragazzine-images-grid');
          const bambineGrid = getEl('bambine-images-grid');
          
          if (type === 'ragazzina') {
            if (ragazzineGrid) ragazzineGrid.style.display = 'grid';
            if (bambineGrid) bambineGrid.style.display = 'none';
          } else {
            if (ragazzineGrid) ragazzineGrid.style.display = 'none';
            if (bambineGrid) bambineGrid.style.display = 'grid';
          }
        });
      });

      // Boy Type Toggle (Ragazzino/Bambino)
      queryAll('.boy-type-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const type = e.target.dataset.boyType;
          
          // Update buttons
          queryAll('.boy-type-btn').forEach(b => {
            b.classList.remove('active');
            b.style.background = '#fff';
            b.style.color = '#333';
            b.style.borderColor = '#e0e0e0';
          });
          e.target.classList.add('active');
          e.target.style.background = '#dd1ad7';
          e.target.style.color = 'white';
          e.target.style.borderColor = '#dd1ad7';

          // Show/Hide grids
          const ragazziniGrid = getEl('ragazzini-images-grid');
          const bambiniGrid = getEl('bambini-images-grid');
          
          if (type === 'ragazzino') {
            if (ragazziniGrid) ragazziniGrid.style.display = 'grid';
            if (bambiniGrid) bambiniGrid.style.display = 'none';
          } else {
            if (ragazziniGrid) ragazziniGrid.style.display = 'none';
            if (bambiniGrid) bambiniGrid.style.display = 'grid';
          }
        });
      });

      // Customization Options
      const optionClasses = ['.hair-btn', '.color-btn', '.facial-hair-btn', '.glasses-btn'];
      optionClasses.forEach(cls => {
        queryAll(cls).forEach(el => {
          el.addEventListener('click', (e) => {
            const group = e.target.closest('.customization-group') || e.target.parentElement;
            group.querySelectorAll(cls).forEach(b => b.classList.remove('selected'));
            e.target.classList.add('selected');
          });
        });
      });

      // Save Character Button
      query('.save-character-btn')?.addEventListener('click', () => this.saveCharacter());

      // Decorations
      queryAll('.decoration-item').forEach(el => {
        el.addEventListener('click', (e) => this.addDecoration(e));
      });

      // Decoration Category Switching
      queryAll('.decoration-selector .category-btn').forEach(btn => {
        btn.addEventListener('click', (e) => {
          const category = e.target.dataset.decorCategory;
          
          // Update buttons
          queryAll('.decoration-selector .category-btn').forEach(b => b.classList.remove('active'));
          e.target.classList.add('active');

          // Show/Hide grids
          queryAll('.decorations-grid').forEach(grid => grid.style.display = 'none');
          const targetGrid = getEl(`decor-grid-${category}`);
          if (targetGrid) targetGrid.style.display = 'grid';
        });
      });

      // Phrase Type Selection
      queryAll('input[name="phrase-type"]').forEach(el => {
        el.addEventListener('change', (e) => this.handlePhraseTypeSelection(e));
      });

      // Standard Phrase Selection
      getEl('standard-phrase-select')?.addEventListener('change', (e) => {
        state.data.phrase = e.target.value;
        this.updateSummary();
      });

      // Custom Phrase Input
      getEl('custom-phrase')?.addEventListener('input', (e) => {
        state.data.phrase = e.target.value;
        this.updateCharacterCount(e.target.value);
        this.updateSummary();
      });

      // Radio Inputs (Calligraphy)
      queryAll('input[name="calligraphy"]').forEach(el => {
        el.addEventListener('change', (e) => {
          state.data[e.target.name] = e.target.value;
          this.updateRadioVisuals(e.target);
          this.updateSummary();
          this.updateCartUI();
        });
      });

      // Add to Cart
      getEl(CONFIG.SELECTORS.ADD_TO_CART_BTN)?.addEventListener('click', () => this.addToCart());
      
      // Header Cart Drawer
      const toggleDrawer = (show) => {
        const drawer = getEl(CONFIG.SELECTORS.HEADER_CART_DRAWER);
        const overlay = getEl(CONFIG.SELECTORS.HEADER_CART_OVERLAY);
        if (drawer && overlay) {
          if (show) {
            drawer.classList.add('active');
            overlay.classList.add('active');
            document.body.style.overflow = 'hidden';
          } else {
            drawer.classList.remove('active');
            overlay.classList.remove('active');
            document.body.style.overflow = '';
          }
        }
      };

      getEl(CONFIG.SELECTORS.HEADER_CART_BTN)?.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleDrawer(true);
      });

      getEl(CONFIG.SELECTORS.HEADER_CART_CLOSE)?.addEventListener('click', () => toggleDrawer(false));
      getEl(CONFIG.SELECTORS.HEADER_CART_OVERLAY)?.addEventListener('click', () => toggleDrawer(false));
    },

    // --- Step Management ---
    changeStep(direction) {
      const newStep = state.currentStep + direction;
      
      // If we are on the last step and clicking next, trigger add to cart
      if (state.currentStep === state.totalSteps && direction > 0) {
        this.addToCart();
        return;
      }

      // Validation check: Block proceeding if current step is invalid
      if (direction > 0 && !this.validateStep(state.currentStep)) return;
      
      if (newStep >= 1 && newStep <= state.totalSteps) {
        state.currentStep = newStep;
        this.updateUI();
        
        // If entering step 2, load backgrounds sequentially
        if (newStep === 2) {
          this.loadBackgroundsSequentially();
        }
      }
    },

    goToStep(step) {
      // Prevent jumping ahead if previous steps are incomplete
      if (step > state.currentStep) {
        for (let i = 1; i < step; i++) {
           if (!this.validateStep(i)) {
             // If step i is invalid, move to that step to show the error
             if (i > state.currentStep) {
                 state.currentStep = i;
                 this.updateUI();
                 // Re-trigger validation to show error in the correct step
                 this.validateStep(i);
             }
             return;
           }
        }
      }

      if (step >= 1 && step <= state.totalSteps) {
        state.currentStep = step;
        this.updateUI();
        
        // If entering step 2, load backgrounds sequentially
        if (step === 2) {
          this.loadBackgroundsSequentially();
        }
      }
    },

    loadBackgroundsSequentially() {
      const images = Array.from(document.querySelectorAll('.background-image.lazy-background'));
      if (images.length === 0) return;

      const loadImage = (index) => {
        if (index >= images.length) return;
        
        const img = images[index];
        if (img.dataset.src) {
          img.src = img.dataset.src;
          img.onload = () => {
            img.classList.remove('lazy-background');
            img.removeAttribute('data-src');
            loadImage(index + 1); // Load next only after current finishes
          };
          img.onerror = () => {
             loadImage(index + 1); // Skip error
          };
        } else {
           loadImage(index + 1);
        }
      };

      loadImage(0);
    },

    updateUI() {
      // Update Steps Visibility
      queryAll(CONFIG.SELECTORS.STEPS).forEach(el => el.classList.remove('active'));
      queryAll(CONFIG.SELECTORS.PROGRESS_STEPS).forEach(el => el.classList.remove('active'));
      
      const currentStepEl = query(`.configurator-step[data-step="${state.currentStep}"]`);
      const currentProgressEl = query(`.progress-step[data-step="${state.currentStep}"]`);
      
      if (currentStepEl) currentStepEl.classList.add('active');
      if (currentProgressEl) {
        currentProgressEl.classList.add('active');
        // Scroll active step into view (centered) for mobile
        currentProgressEl.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }

      // Update Buttons
      const prevBtn = getEl(CONFIG.SELECTORS.PREV_BTN);
      const nextBtn = getEl(CONFIG.SELECTORS.NEXT_BTN);
      
      if (prevBtn) prevBtn.disabled = state.currentStep === 1;
      if (nextBtn) {
        const arrowIcon = nextBtn.querySelector('.nav-icon-arrow');
        const checkIcon = nextBtn.querySelector('.nav-icon-check');
        if (arrowIcon && checkIcon) {
          const isLastStep = state.currentStep === state.totalSteps;
          arrowIcon.style.display = isLastStep ? 'none' : '';
          checkIcon.style.display = isLastStep ? '' : 'none';
        } else {
          const arrow = nextBtn.querySelector('.nav-arrow');
          if (arrow) arrow.textContent = state.currentStep === state.totalSteps ? '✓' : '→';
        }
      }

      if (state.currentStep === 6) {
        this.updateSummary();
        this.validateSummary();
      }
    },

    validateStep(step) {
      let isValid = false;
      let errorMsg = '';

      switch(step) {
        case 1:
          isValid = !!state.data.frame;
          errorMsg = 'Seleziona una cornice';
          break;
        case 2:
          isValid = !!state.data.background;
          errorMsg = 'Seleziona uno sfondo';
          break;
        case 3:
          isValid = state.data.characters.length > 0;
          errorMsg = 'Aggiungi almeno un personaggio';
          break;
        case 5:
          isValid = state.data.phrase.trim().length > 0;
          errorMsg = 'Seleziona o scrivi una frase';
          break;
        default:
          isValid = true;
      }

      if (!isValid) this.showError(errorMsg);
      return isValid;
    },

    validateSummary() {
      const missing = [];
      // Relaxed validation: Check if AT LEAST ONE item is selected
      const hasSelection = state.data.frame || 
                           state.data.characters.length > 0 || 
                           state.data.decorations.length > 0 || 
                           state.data.background || 
                           (state.data.phrase && state.data.phraseType === 'custom');

      if (!hasSelection) missing.push('Almeno un prodotto');
      
      const btn = getEl(CONFIG.SELECTORS.ADD_TO_CART_BTN);
      const summaryContainer = query('.order-summary-container');
      const existingWarning = query('.summary-warning');
      if (existingWarning) existingWarning.remove();

      if (missing.length > 0) {
        if (btn) {
          btn.disabled = true;
          btn.style.opacity = '0.5';
          btn.style.cursor = 'not-allowed';
        }
        
        const warning = document.createElement('div');
        warning.className = 'summary-warning';
        warning.style.cssText = 'background:#ffebee;color:#c62828;padding:15px;border-radius:8px;margin-bottom:20px;text-align:center;border:1px solid #ef9a9a;font-weight:600;';
        warning.innerHTML = `⚠️ Per procedere, devi selezionare almeno un elemento.`;
        
        if (summaryContainer) {
          summaryContainer.insertBefore(warning, summaryContainer.firstChild);
        }
      } else {
        if (btn) {
          btn.disabled = false;
          btn.style.opacity = '1';
          btn.style.cursor = 'pointer';
        }
      }
    },

    showError(msg) {
      const existing = query('.validation-error');
      if (existing) existing.remove();

      const errorDiv = document.createElement('div');
      errorDiv.className = 'validation-error';
      errorDiv.style.cssText = 'background:#ffebee;color:#c62828;padding:10px;border-radius:8px;margin-bottom:15px;text-align:center;border:1px solid #ef9a9a;';
      errorDiv.textContent = `⚠️ ${msg}`;
      
      const container = query('.configurator-step.active .step-content');
      container.insertBefore(errorDiv, container.firstChild);
      setTimeout(() => errorDiv.remove(), 3000);
    },

    // --- Selection Handlers ---
    handleFrameSelection(e) {
      const target = e.currentTarget;
      queryAll('.frame-option').forEach(el => el.classList.remove('selected'));
      target.classList.add('selected');
      
      state.data.frame = target.dataset.frame;
      state.data.framePrice = parseInt(target.dataset.price);
      this.updateCartUI();
    },

    handleBackgroundSelection(e) {
      const target = e.currentTarget;
      queryAll('.background-option').forEach(el => el.classList.remove('selected'));
      target.classList.add('selected');
      
      state.data.background = target.dataset.background;
      state.data.backgroundPrice = parseInt(target.dataset.price);
      this.updateCartUI();
    },

    handleCategorySelection(e) {
      const btn = e.currentTarget;
      const category = btn.dataset.category;
      
      queryAll('.category-btn').forEach(b => b.classList.remove('active'));
      query('.category-selector').classList.add('has-selection');
      btn.classList.add('active');

      ['woman', 'man', 'boy', 'girl', 'baby', 'animal', 'character-customization'].forEach(id => {
        const el = getEl(id === 'character-customization' ? id : `${id}-selection`);
        if (el) el.style.display = 'none';
      });

      if (['woman', 'man', 'boy', 'girl', 'baby', 'animal'].includes(category)) {
        const section = getEl(`${category}-selection`);
        if (section) {
          section.style.display = 'block';
          section.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
      this.currentCategory = category;
    },

    handleTypeSelection(e, selector) {
      const target = e.currentTarget;
      queryAll(selector).forEach(el => el.classList.remove('selected'));
      target.classList.add('selected');

      // For animals, we need to know if it's dog or cat
      if (this.currentCategory === 'animal') {
        this.currentType = target.dataset.id;
        this.currentAnimalType = target.dataset.animal; // 'dog' or 'cat'
      } else if (this.currentCategory === 'girl') {
        this.currentType = target.dataset.id;
        this.currentGirlType = target.dataset.girlCategory; // 'ragazzina' or 'bambina'
      } else if (this.currentCategory === 'boy') {
        this.currentType = target.dataset.id;
        this.currentBoyType = target.dataset.boyCategory; // 'ragazzino' or 'bambino'
      } else {
        this.currentType = target.dataset.woman || target.dataset.man || target.dataset.type || target.dataset.baby;
      }

      const customSection = getEl('character-customization');
      customSection.style.display = 'block';
      customSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

      // Handle visibility of customization options
      const manOnly = query('.man-only');
      if (manOnly) manOnly.style.display = this.currentCategory === 'man' ? 'block' : 'none';

      // Hide all customization groups except name for baby and animal
      const allGroups = customSection.querySelectorAll('.customization-group');
      allGroups.forEach(group => {
        // Always show name input
        if (group.querySelector('.character-name')) {
          group.style.display = 'block';
        } else {
          // Hide other groups if baby or animal
          group.style.display = (this.currentCategory === 'baby' || this.currentCategory === 'animal') ? 'none' : 'block';
        }
      });
      
      // Re-apply man-only logic if not baby/animal
      if (this.currentCategory !== 'baby' && this.currentCategory !== 'animal' && manOnly) {
         manOnly.style.display = this.currentCategory === 'man' ? 'block' : 'none';
      }
    },

    handlePhraseTypeSelection(e) {
      state.data.phraseType = e.target.value;
      const standardContainer = getEl('standard-phrase-container');
      const customContainer = getEl('custom-phrase-container');
      
      if (state.data.phraseType === 'standard') {
        standardContainer.style.display = 'block';
        customContainer.style.display = 'none';
        state.data.phrase = getEl('standard-phrase-select').value;
      } else {
        standardContainer.style.display = 'none';
        customContainer.style.display = 'block';
        state.data.phrase = getEl('custom-phrase').value;
      }
      this.updateSummary();
      this.updateCartUI();
    },

    // --- Character Management ---
    saveCharacter() {
      const nameInput = query('.character-name');
      const name = nameInput.value.trim();
      
      if (!name) return this.showError('Inserisci un nome');
      if (!this.currentType) return this.showError('Seleziona uno stile');

      const getSelected = (cls, attr) => query(`${cls}.selected`)?.dataset[attr] || null;

      const character = {
        id: Date.now(),
        category: this.currentCategory,
        type: this.currentType,
        animalType: this.currentAnimalType, // 'dog' or 'cat' if animal
        name: name,
        hairType: getSelected('.hair-btn', 'hair'),
        hairColor: getSelected('.hair-color-options .color-btn', 'color'),
        skinColor: getSelected('.skin-color-options .color-btn', 'skin'),
        glasses: getSelected('.glasses-btn', 'glasses') || 'none',
        facialHair: this.currentCategory === 'man' ? (getSelected('.facial-hair-btn', 'facial') || 'none') : null,
        image: this.getImageName()
      };

      state.data.characters.push(character);
      this.resetCharacterForm();
      this.updateCartUI();
      // No alert
    },

    getImageName() {
      if (this.currentCategory === 'woman') {
        return `donne/${this.currentType}`;
      }

      if (this.currentCategory === 'man') {
        return `uomini/${this.currentType}`;
      }

      if (this.currentCategory === 'girl') {
        const type = this.currentGirlType === 'ragazzina' ? 'ragazzine' : 'bambine';
        return `${type}/${this.currentType}`;
      }

      if (this.currentCategory === 'boy') {
        const type = this.currentBoyType === 'ragazzino' ? 'ragazzini' : 'bambini';
        return `${type}/${this.currentType}`;
      }

      if (this.currentCategory === 'baby') {
        return `bebe/bimbo-${this.currentType}.png`;
      }
      
      if (this.currentCategory === 'animal') {
        const type = this.currentAnimalType === 'dog' ? 'cane' : 'gatto';
        return `animali/${type}/${type}${this.currentType}.png`;
      }

      return null;
    },

    resetCharacterForm() {
      query('.character-name').value = '';
      queryAll('.selected').forEach(el => el.classList.remove('selected'));
      getEl('character-customization').style.display = 'none';
      ['woman', 'man', 'boy', 'girl', 'baby', 'animal'].forEach(c => {
        const el = getEl(`${c}-selection`);
        if (el) el.style.display = 'none';
      });
      query('.category-selector').classList.remove('has-selection');
      queryAll('.category-btn').forEach(b => b.classList.remove('active'));
      this.currentCategory = null;
      this.currentType = null;
      this.currentAnimalType = null;
      this.currentGirlType = null;
      this.currentBoyType = null;
    },

    // --- Decorations ---
    addDecoration(e) {
      const target = e.currentTarget;
      const type = target.dataset.decoration; // category (e.g., natale)
      const id = target.dataset.id; // number (e.g., 1)
      const name = target.dataset.name;
      
      // Unique key for this decoration type+id
      const uniqueKey = `${type}-${id}`;

      let decor = state.data.decorations.find(d => d.uniqueKey === uniqueKey);
      if (!decor) {
        decor = { type, id, name, uniqueKey, count: 0 };
        state.data.decorations.push(decor);
      }
      decor.count++;
      this.updateDecorationVisuals();
      this.updateSummary();
      this.updateCartUI();
    },

    removeDecoration(uniqueKey) {
      state.data.decorations = state.data.decorations.filter(d => d.uniqueKey !== uniqueKey);
      this.updateDecorationVisuals();
      this.updateSummary();
      this.updateCartUI();
    },

    updateDecorationVisuals() {
      // Calculate total selected count to determine free/paid status
      const hasFrame = !!state.data.frame;
      const freeLimit = hasFrame ? CONFIG.PRICES.FREE_DECORATIONS_LIMIT : 0;
      let freeSlots = freeLimit;

      // We need to iterate through decorations in a consistent order to assign free/paid status
      // state.data.decorations preserves insertion order of types, but we need to handle counts
      // Let's create a map of paid counts per uniqueKey
      const paidCounts = {};

      state.data.decorations.forEach(d => {
        let paidForThis = 0;
        for (let i = 0; i < d.count; i++) {
          if (freeSlots > 0) {
            freeSlots--;
          } else {
            paidForThis++;
          }
        }
        paidCounts[d.uniqueKey] = paidForThis;
      });

      queryAll('.decoration-item').forEach(item => {
        const type = item.dataset.decoration;
        const id = item.dataset.id;
        const uniqueKey = `${type}-${id}`;
        
        const decor = state.data.decorations.find(d => d.uniqueKey === uniqueKey);
        const counter = item.querySelector('.decoration-counter');
        const priceBadge = item.querySelector('.decoration-price-badge');
        
        if (decor && decor.count > 0) {
          counter.textContent = decor.count;
          counter.classList.add('visible');
          item.classList.add('active');

          // Update price badge
          const paidCount = paidCounts[uniqueKey] || 0;
          if (paidCount > 0) {
            const extraCost = paidCount * CONFIG.PRICES.DECORATION;
            priceBadge.textContent = `+${extraCost}€`;
            priceBadge.classList.add('visible');
          } else {
            priceBadge.classList.remove('visible');
          }

        } else {
          counter.classList.remove('visible');
          if (priceBadge) priceBadge.classList.remove('visible');
          item.classList.remove('active');
        }
      });

      const container = query('#selected-decorations .selected-list');
      if (container) {
        const activeDecors = state.data.decorations.filter(d => d.count > 0);
        if (activeDecors.length === 0) {
          container.innerHTML = '<p style="color:#666;font-style:italic">Nessun decoro</p>';
        } else {
          // Check if frame is selected to determine if free
          const hasFrame = !!state.data.frame;
          let freeSlots = hasFrame ? CONFIG.PRICES.FREE_DECORATIONS_LIMIT : 0;

          // We need to iterate to determine status for display
          // But here we just show the list. The status is shown in summary.
          // However, user might want to see status here too?
          // For now, just show count.
          
          container.innerHTML = activeDecors.map(d => `
            <div class="selected-decoration">
              <span>${d.name} x${d.count}</span>
              <button class="remove-decoration" data-key="${d.uniqueKey}">×</button>
            </div>
          `).join('');
          container.querySelectorAll('.remove-decoration').forEach(btn => {
            btn.addEventListener('click', (e) => this.removeDecoration(e.target.dataset.key));
          });
        }
      }
    },

    // --- Summary ---
    updateSummary() {
      // Frame
      const frameName = state.data.frame === 'natural' ? 'Legno naturale' : (state.data.frame === 'white' ? 'Legno bianco' : '-');
      getEl('summary-frame').textContent = frameName;
      getEl('summary-frame-price').textContent = formatMoney(state.data.framePrice);

      // Characters
      const charList = getEl('characters-detail-list');
      if (charList) {
        charList.innerHTML = state.data.characters.length ? state.data.characters.map(c => {
          const details = this.formatCharacterDetails(c);
          return `
          <div class="summary-item" style="flex-direction:column; align-items:flex-start; gap:5px;">
            <div style="display:flex; justify-content:space-between; width:100%;">
              <span class="item-name"><strong>${c.name}</strong> (${c.category})</span>
              <span class="item-price">${formatMoney(CONFIG.PRICES.CHARACTER)}</span>
            </div>
            <div style="font-size:0.85rem; color:#666; font-style:italic;">
              ${details}
            </div>
          </div>
        `}).join('') : '<div class="summary-item"><span>Nessun personaggio</span><span>0€</span></div>';
      }
      getEl('summary-characters').textContent = state.data.characters.length;
      getEl('summary-characters-price').textContent = formatMoney(state.data.characters.length * CONFIG.PRICES.CHARACTER);

      // Decorations
      const hasFrame = !!state.data.frame;
      const freeLimit = hasFrame ? CONFIG.PRICES.FREE_DECORATIONS_LIMIT : 0;

      const totalDecors = state.data.decorations.reduce((sum, d) => sum + d.count, 0);
      const paidDecors = Math.max(0, totalDecors - freeLimit);
      const decorPrice = paidDecors * CONFIG.PRICES.DECORATION;
      getEl('summary-decorations-price').textContent = formatMoney(decorPrice);
      
      const decorList = getEl('decorations-detail-list');
      if (decorList) {
        const active = state.data.decorations.filter(d => d.count > 0);
        
        let freeSlots = freeLimit;
        let html = '';
        
        if (active.length === 0) {
          html = '<div class="summary-item"><span>Nessun decoro</span><span>0€</span></div>';
        } else {
          active.forEach(d => {
            for (let i = 0; i < d.count; i++) {
              const isFree = freeSlots > 0;
              if (isFree) freeSlots--;
              const label = isFree ? 'Gratis' : `${formatMoney(CONFIG.PRICES.DECORATION)}`;
              const status = isFree ? 'Gratis' : 'Extra';
              
              html += `
                <div class="summary-item">
                  <span class="item-name">Decorazione ${d.type} ${status} ${d.id}</span>
                  <span class="item-price">${label}</span>
                </div>
              `;
            }
          });
        }
        decorList.innerHTML = html;
      }

      // Customization
      const customList = getEl('customization-detail-list');
      if (customList) {
        let html = '';
        if (state.data.background) html += `<div class="summary-item"><span>Sfondo ${state.data.background}</span><span>${formatMoney(state.data.backgroundPrice)}</span></div>`;
        
        // Phrase logic
        if (state.data.phrase) {
          const isCustom = state.data.phraseType === 'custom';
          const phrasePrice = isCustom ? CONFIG.PRICES.CUSTOM_PHRASE : 0;
          const priceLabel = isCustom ? formatMoney(phrasePrice) : 'Incluso';
          html += `<div class="summary-item"><span>Frase: "${state.data.phrase}"</span><span>${priceLabel}</span></div>`;
        }

        if (state.data.calligraphy === 'elegante') html += `<div class="summary-item"><span>Calligrafia Elegante</span><span>${formatMoney(CONFIG.PRICES.CALLIGRAPHY)}</span></div>`;
        customList.innerHTML = html || '<div class="summary-item"><span>Nessuna personalizzazione</span><span>0€</span></div>';
      }

      // Total
      const phraseCost = (state.data.phrase && state.data.phraseType === 'custom') ? CONFIG.PRICES.CUSTOM_PHRASE : 0;
      const total = state.data.framePrice + 
                    state.data.backgroundPrice +
                    (state.data.characters.length * CONFIG.PRICES.CHARACTER) + 
                    decorPrice + 
                    phraseCost +
                    (state.data.calligraphy === 'elegante' ? CONFIG.PRICES.CALLIGRAPHY : 0);
      
      getEl('total-price').textContent = formatMoney(total);

      // Cart Summary in Step 6
      const cartSummaryContainer = getEl('cart-summary-section');
      if (!cartSummaryContainer) {
        // Create it if it doesn't exist
        const container = query('.order-summary-container');
        if (container) {
            const section = document.createElement('div');
            section.id = 'cart-summary-section';
            section.className = 'summary-section';
            section.style.display = 'none';
            section.style.borderTop = '2px dashed #eee';
            section.style.marginTop = '20px';
            section.style.paddingTop = '20px';
            
            // Insert before total
            const totalLine = query('.order-total');
            if (totalLine) {
                container.insertBefore(section, totalLine);
            }
        }
      }

      const cartSection = getEl('cart-summary-section');
      if (cartSection) {
        if (state.cart.item_count > 0) {
            cartSection.style.display = 'block';
            cartSection.innerHTML = `
                <div class="section-header">
                    <h4 style="color:#666">Già nel carrello (${state.cart.item_count} articoli)</h4>
                </div>
                <div class="section-content">
                    ${state.cart.items.map(item => `
                        <div class="summary-item" style="color:#888">
                            <span class="item-name">${item.product_title} x${item.quantity}</span>
                            <span class="item-price">${formatMoneyCents(item.final_line_price)}</span>
                        </div>
                    `).join('')}
                    <div class="summary-item" style="font-weight:bold; margin-top:10px; border-top:1px solid #eee; padding-top:10px;">
                        <span>Totale Carrello</span>
                        <span>${formatMoneyCents(state.cart.total_price)}</span>
                    </div>
                </div>
            `;
        } else {
            cartSection.style.display = 'none';
        }
      }
    },

    // --- Cart Logic ---
    fetchCart() {
      fetch(LIQUID_CONFIG.routes.cart + '.js?v=' + Date.now())
        .then(res => res.json())
        .then(cart => {
          state.cart = cart;
          this.updateCartUI();
        })
        .catch(err => console.error('Error fetching cart:', err));
    },

    updateCartUI() {
      // 1. Calculate Virtual Items (Current Configuration)
      const virtualItems = [];
      let virtualCount = 0;

      // Frame
      if (state.data.frame) {
        const name = state.data.frame === 'natural' ? 'Legno naturale' : 'Legno bianco';
        virtualItems.push({ 
          title: `Cornice: ${name}`, 
          price: state.data.framePrice, 
          quantity: 1 
        });
        virtualCount++;
      }
      
      // Background
      if (state.data.background) {
        virtualItems.push({ 
          title: `Sfondo ${state.data.background}`, 
          price: state.data.backgroundPrice, 
          quantity: 1 
        });
        virtualCount++;
      }

      // Characters
      if (state.data.characters.length > 0) {
        const count = state.data.characters.length;
        const price = count * CONFIG.PRICES.CHARACTER;
        virtualItems.push({ 
          title: `Personaggi`, 
          price: price, 
          quantity: count, 
          variant: `${count} selezionati` 
        });
        virtualCount += count;
      }

      // Decorations
      const hasFrame = !!state.data.frame;
      const freeLimit = hasFrame ? CONFIG.PRICES.FREE_DECORATIONS_LIMIT : 0;
      const totalDecors = state.data.decorations.reduce((sum, d) => sum + d.count, 0);
      const paidDecors = Math.max(0, totalDecors - freeLimit);
      
      if (totalDecors > 0) {
         const price = paidDecors * CONFIG.PRICES.DECORATION;
         virtualItems.push({ 
           title: `Decori`, 
           price: price, 
           quantity: totalDecors, 
           variant: `${totalDecors} selezionati (${paidDecors} extra)` 
         });
         virtualCount += totalDecors;
      }

      // Calligraphy
      if (state.data.calligraphy === 'elegante') {
        virtualItems.push({
          title: 'Calligrafia Elegante',
          price: CONFIG.PRICES.CALLIGRAPHY,
          quantity: 1
        });
        virtualCount++;
      }

      // Custom Phrase
      if (state.data.phrase && state.data.phraseType === 'custom') {
        virtualItems.push({
          title: 'Frase Personalizzata',
          price: CONFIG.PRICES.CUSTOM_PHRASE,
          quantity: 1
        });
        virtualCount++;
      }

      // 2. Update Badge
      const totalCount = state.cart.item_count + virtualCount;
      const badge = getEl(CONFIG.SELECTORS.HEADER_CART_COUNT);
      if (badge) {
        badge.textContent = totalCount;
      }

      // 3. Render Dropdown
      const dropdownItems = getEl(CONFIG.SELECTORS.DROPDOWN_ITEMS);
      if (dropdownItems) {
         let html = '';
         
         // Virtual Items Section
         if (virtualItems.length > 0) {
             html += `<div class="drawer-section-title" style="padding:10px 20px; background:#f9f9f9; font-weight:bold; font-size:0.9rem; color:#333;">In configurazione</div>`;
             html += virtualItems.map(item => `
                <div class="dropdown-item" style="opacity:0.9; background:#fff;">
                  <div class="dropdown-item-info" style="width:100%">
                    <div class="dropdown-item-title" style="font-weight:500;">${item.title}</div>
                    <div class="dropdown-item-price">${formatMoney(item.price)} ${item.quantity > 1 ? `(x${item.quantity})` : ''}</div>
                    ${item.variant ? `<div style="font-size:0.8rem;color:#888;">${item.variant}</div>` : ''}
                  </div>
                </div>
             `).join('');
         }

         // Actual Cart Section
         if (state.cart.item_count > 0) {
             if (virtualItems.length > 0) {
                 html += `<div class="drawer-section-title" style="padding:10px 20px; background:#f9f9f9; font-weight:bold; font-size:0.9rem; border-top:1px solid #eee; color:#333;">Nel carrello</div>`;
             }
             html += state.cart.items.map((item, index) => {
                 const imgUrl = item.image ? item.image : '//cdn.shopify.com/s/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif';
                 return `
                    <div class="dropdown-item">
                      <img src="${imgUrl}" alt="${item.title}">
                      <div class="dropdown-item-info">
                        <div class="dropdown-item-title">${item.product_title}</div>
                        <div class="dropdown-item-price">${formatMoneyCents(item.final_line_price)}</div>
                        ${item.variant_title && item.variant_title !== 'Default Title' ? `<div style="font-size:0.8rem;color:#888;margin-top:2px;">${item.variant_title}</div>` : ''}
                      </div>
                      <button class="remove-item-btn" data-line="${index + 1}" aria-label="Rimuovi">&times;</button>
                    </div>
                 `;
             }).join('');
         } else if (virtualItems.length === 0) {
             html = '<div style="padding:20px;text-align:center;color:#666">Il carrello è vuoto</div>';
         }

         dropdownItems.innerHTML = html;
         
         // Re-attach listeners for remove buttons
         dropdownItems.querySelectorAll('.remove-item-btn').forEach(btn => {
            btn.addEventListener('click', (e) => {
              const line = parseInt(e.target.dataset.line);
              this.removeFromCart(line);
            });
          });
      }
      
      // Show/Hide Header Cart Button (Always show)
      const wrapper = getEl(CONFIG.SELECTORS.HEADER_CART_WRAPPER);
      if (wrapper) {
        wrapper.style.display = 'block';
      }
    },

    removeFromCart(line) {
      const url = (LIQUID_CONFIG.routes && LIQUID_CONFIG.routes.cart_change_url) ? LIQUID_CONFIG.routes.cart_change_url : '/cart/change.js';
      
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(res => res.json())
      .then(cart => {
        state.cart = cart;
        this.updateCartUI();
        // If cart is empty, close drawer after a delay? Or keep open.
        if (cart.item_count === 0) {
          // Optional: toggleDrawer(false);
        }
      })
      .catch(err => console.error('Error removing item:', err));
    },

    addToCart() {
      const items = [];
      const missing = [];

      // 1. Frame (Main Item)
      let frameProps = {};
      if (state.data.frame) {
        const frameId = state.data.frame === 'natural' ? LIQUID_CONFIG.variants.natural : LIQUID_CONFIG.variants.white;
        const frameImage = state.data.frame === 'natural' ? 'cornicemarroneclean.png' : 'cornicebiancaclean.png';
        
        if (frameId) {
            frameProps = {
                'Configurazione': 'MyFamily',
                '_image': frameImage
            };
            
            // If standard phrase (no extra item), attach it here
            if (state.data.phrase && state.data.phraseType === 'standard') {
                frameProps['Frase'] = state.data.phrase;
            }

            // If standard background (0€), attach it here
            if (state.data.background === 'standard-black') {
                frameProps['Sfondo'] = 'Standard Nero';
            }
            
            // Calligraphy Standard
            if (state.data.calligraphy !== 'elegante') {
                 frameProps['Stile Calligrafia'] = 'Standard';
            }

            items.push({ id: parseInt(frameId), quantity: 1, properties: frameProps });
        }
      }

      // 2. Background
      if (state.data.background && state.data.background !== 'standard-black') {
        const id = LIQUID_CONFIG.variants.background;
        if (id) {
          items.push({ 
            id: parseInt(id), 
            quantity: 1,
            properties: { 
              'Modello': `Sfondo ${state.data.background}`,
              '_image': `SFONDI/sfondo-${state.data.background}.jpeg`
            }
          });
        } else {
          missing.push('Sfondo');
        }
      }

      // 3. Characters (Split into individual items for specific images)
      if (state.data.characters.length > 0) {
        const id = LIQUID_CONFIG.variants.character;
        if (id) {
          state.data.characters.forEach(c => {
            const details = this.formatCharacterDetails(c);
            items.push({ 
              id: parseInt(id), 
              quantity: 1,
              properties: { 
                'Dettagli': `${c.name} (${c.category}): ${details}`,
                '_image': c.image,
                '_unique_id': Date.now() + Math.random().toString() // Ensure separate line items
              }
            });
          });
        } else {
          missing.push('Personaggio Extra');
        }
      }

      // 4. Decorations
      const hasFrame = !!state.data.frame;
      const freeLimit = hasFrame ? CONFIG.PRICES.FREE_DECORATIONS_LIMIT : 0;

      const totalDecors = state.data.decorations.reduce((sum, d) => sum + d.count, 0);
      const paidDecors = Math.max(0, totalDecors - freeLimit);
      
      // Generate list of decorations with Free/Extra status
      let freeSlots = freeLimit;
      const decorDetailsList = [];
      const paidDecorItems = [];
      
      state.data.decorations.forEach(d => {
        for (let i = 0; i < d.count; i++) {
          const isFree = freeSlots > 0;
          if (isFree) freeSlots--;
          const status = isFree ? 'Gratis' : 'Extra';
          decorDetailsList.push(`Decorazione ${d.type} ${status} ${d.id}`);
          
          if (status === 'Extra') {
            paidDecorItems.push({
              type: d.type,
              id: d.id
            });
          }
        }
      });
      
      const decorListString = decorDetailsList.join(', ');
      
      if (paidDecorItems.length > 0) {
        const id = LIQUID_CONFIG.variants.decoration;
        if (id) {
          // Split paid decorations to show images
          paidDecorItems.forEach(d => {
            items.push({ 
              id: parseInt(id), 
              quantity: 1,
              properties: { 
                'Dettagli': `Decorazione ${d.type} ${d.id}`,
                '_image': `decorazioni/${d.type}/decoro${d.id}.png`,
                '_unique_id': Date.now() + Math.random().toString()
              }
            });
          });
        } else {
          missing.push('Decoro Extra');
        }
      }
      
      // Attach free decorations list to frame
      if (decorListString && hasFrame && items.length > 0 && items[0].properties) {
         items[0].properties['Decori'] = decorListString;
      }

      // 5. Calligraphy
      if (state.data.calligraphy === 'elegante') {
        const id = LIQUID_CONFIG.variants.calligraphy;
        if (id) {
          items.push({ 
            id: parseInt(id), 
            quantity: 1,
            properties: { 'Stile': 'Elegante' }
          });
        } else {
          missing.push('Calligrafia Elegante');
        }
      }

      // 6. Custom Phrase
      if (state.data.phrase && state.data.phraseType === 'custom') {
        const id = LIQUID_CONFIG.variants.custom_phrase;
        if (id) {
          items.push({ 
            id: parseInt(id), 
            quantity: 1,
            properties: { 'Testo': state.data.phrase }
          });
        } else {
          missing.push('Frase Personalizzata');
        }
      }

      if (missing.length) return this.showError(`Prodotti mancanti: ${missing.join(', ')}`);
      if (items.length === 0) return this.showError('Nessun prodotto selezionato');

      const btn = getEl(CONFIG.SELECTORS.ADD_TO_CART_BTN);
      const originalText = btn.innerHTML;
      btn.innerHTML = 'Caricamento...';
      btn.disabled = true;

      // Use .js endpoint for AJAX
      const cartAddUrl = LIQUID_CONFIG.routes.cart_add.endsWith('.js') 
        ? LIQUID_CONFIG.routes.cart_add 
        : LIQUID_CONFIG.routes.cart_add + '.js';

      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(res => res.json())
      .then(data => {
        if (data.status) throw new Error(data.description);
        
        // Success!
        // Redirect to cart page
        window.location.href = LIQUID_CONFIG.routes.cart;

      })
      .catch(err => {
        console.error(err);
        this.showError('Errore carrello: ' + err.message);
        btn.innerHTML = originalText;
        btn.disabled = false;
      });
    },

    // --- Helpers ---
    updateCharacterCount(text) {
      const counter = getEl('char-count');
      if (counter) {
        counter.textContent = text.length;
        counter.parentElement.style.color = text.length > 45 ? '#ff4757' : (text.length > 35 ? '#ff9f43' : '#666');
      }
    },

    updateRadioVisuals(input) {
      const container = input.closest('.option-items');
      container.querySelectorAll('.option-item').forEach(el => el.classList.remove('selected'));
      input.closest('.option-item').classList.add('selected');
    },

    getFacialHairLabel(code) {
      const map = {
        'barba1': 'Baffi',
        'barba2': 'Barba',
        'barba3': 'Barba Lunga',
        'barba4': 'Nessuna',
        'barba5': 'Barbetta',
        'barba6': 'Pizzetto e Baffi',
        'barba7': 'Pizzetto'
      };
      return map[code] || code;
    },

    formatCharacterDetails(c) {
      if (c.category === 'animal') {
        const typeLabel = c.animalType === 'dog' ? 'Cane' : 'Gatto';
        return `Personaggio ${typeLabel} ${c.type}`;
      }

      if (c.category === 'baby') {
        return `Bebé ${c.type}`;
      }
      
      const parts = [];
      if (c.hairType) parts.push(`Capelli: ${c.hairType}`);
      if (c.hairColor) parts.push(`Colore: ${c.hairColor}`);
      if (c.skinColor) parts.push(`Pelle: ${c.skinColor}`);
      if (c.glasses && c.glasses !== 'none') parts.push(`Occhiali: ${c.glasses}`);
      if (c.facialHair && c.facialHair !== 'none') {
        parts.push(`Barba: ${this.getFacialHairLabel(c.facialHair)}`);
      }
      return parts.join(', ');
    },
  };

  Configurator.init();
});